import React from "react";

import errorImgSrc from "../../../image/profile/empty-sims.png";

import { FilterResultP, SimsRow } from "./styledSims";
import SingleSimCardComponent from "../singleSimCard";

const SimsComponent = ({ simsData, showFilters, isProfile, noSimsErrorMessage }) => {
  const { product, error, loading } = simsData;
  let noSimsError = null;
  if (product && product.count === 0) {
    noSimsError = noSimsErrorMessage ? noSimsErrorMessage : "هیچ نتیجه‌ای یافت نشد.";
  }

  const SimsErrorComponent = ({ errorMessage }) => {
    return (
      <div className="text-center">
        <p className="py-3">{errorMessage}</p>
        <img src={errorImgSrc} alt="ارور" className="img-fluid" />
      </div>
    );
  };

  let element = null;
  if (loading) {
    element = (
      <SimsRow $isProfile={isProfile}>
        {new Array(12).fill("").map((item, index) => {
          return <SingleSimCardComponent key={index} data={item} className="my-4" />;
        })}
      </SimsRow>
    );
  } else if (error || noSimsError) {
    element = (
      <SimsErrorComponent
        errorMessage={noSimsError ? noSimsError : "مشکل خوردیم!"}
      />
    );
  } else if (product) {
    element = (
      <SimsRow $isProfile={isProfile}>
        {product.results.map((item, index) => {
          return <SingleSimCardComponent key={index} data={item} className="my-4" />;
        })}
      </SimsRow>
    );
  }
  return (
    <div>
      {showFilters && (
        <FilterResultP className="text-center mt-5">
          <strong>نتایج فیلتر: </strong>
          <span>{product?.count} آزمایش</span>
        </FilterResultP>
      )}
      {element}
    </div>
  );
};

export default SimsComponent;
